import { getProviderNameFromUtmSource } from "utils/adaya/CampaignUtils";

/**
 * @description This is a simple class to help translate Campaign, Adset,
 * and Ad ID or names for different features of the application.
 * The campaign/adset/ad data is initially pulled and set from AccountDataModules.
 * @class CampaignsHelper
 */
class CampaignHelper {

    data = undefined;

    constructor() {}

    setCampaignList = (data) => {
        this.data = data;
    }

    // Return the given name from list of existing campaigns, or otherwise the passed in id.
    lookupCampaignName = (idOrName, utmSource?) => {
        if (!idOrName) return '';
        let provider = utmSource ? getProviderNameFromUtmSource(utmSource) : undefined;
        let c = this.lookForCampaign(idOrName, provider);
        if (c) return c.name;
        return idOrName;
    }

    lookupAdsetName = (idOrName, utmSource?) => {
        if (!idOrName) return '';
        let provider = utmSource ? getProviderNameFromUtmSource(utmSource) : undefined;
        let c = this.lookForAdset(idOrName, provider);
        if (c) return c.name;
        return idOrName;
    }

    lookupAdName = (idOrName, utmSource?) => {
        if (!idOrName) return '';
        let provider = utmSource ? getProviderNameFromUtmSource(utmSource) : undefined;
        let c = this.lookForAd(idOrName, provider);
        if (c) return c.name;
        return idOrName;
    }

    lookForCampaign = (idOrName, provider?) => {
        if (!idOrName || !this.data || !this.data.campaigns) {
            return undefined;
        }
        for (const c of this.data.campaigns) {
            if (c.id == idOrName || c.name == idOrName) {
                if (provider) {
                    if (c.provider == provider)
                        return c;
                } else {
                    return c;
                }
            }
        }
        return undefined;
    }

    lookForAdset = (idOrName, provider?) => {
        if (!idOrName || !this.data || !this.data.adsets)
            return undefined;
        for (const c of this.data.adsets) {
            if (c.id == idOrName || c.name == idOrName) {
                if (provider) {
                    if (c.provider == provider)
                        return c;
                } else {
                    return c;
                }
            }
        }
        return undefined;
    }

    lookForAd = (idOrName, provider?) => {
        if (!idOrName || !this.data || !this.data.ads)
            return undefined;
        for (const c of this.data.ads) {
            if (c.id == idOrName || c.name == idOrName) {
                if (provider) {
                    if (c.provider == provider)
                        return c;
                } else {
                    return c;
                }
            }
        }
        return undefined;
    }

    isKnownCampaign = (o, utmSource?) => {
        if (o.isKnown) return true;
        let provider = utmSource ? getProviderNameFromUtmSource(utmSource) : undefined;
        let id = o.ad_id || o.ad_name || o.Ad;
        let campaign = this.lookForCampaign(id, provider);
        if (campaign) {
            return true;
        }
        return false;
    }

    isKnownAdset = (o, utmSource?) => {
        if (o.isKnown) return true;
        let provider = utmSource ? getProviderNameFromUtmSource(utmSource) : undefined;
        let id = o.adset_id || o.adset_name || o.adset;
        let adset = this.lookForAdset(id, provider);
        if (adset) {
            return true;
        }
        return false;
    }

    isKnownAd = (o, utmSource?) => {
        if (o.isKnown) return true;
        let provider = utmSource ? getProviderNameFromUtmSource(utmSource) : undefined;
        let id = o.ad_id || o.ad_name || o.Ad;
        let ad = this.lookForAd(id, provider);
        if (ad) {
            return true;
        }
        return false;
    }
}

export default new CampaignHelper();
